import { __extends } from "tslib";
import { ASObject } from './ASObject';
import { defineNonEnumerableProperty } from '@awayfl/swf-loader';
var ASMath = /** @class */ (function (_super) {
    __extends(ASMath, _super);
    function ASMath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ASMath.classNatives = [Math];
    ASMath.classInitializer = function () {
        defineNonEnumerableProperty(this, '$BgE', Math.E);
        defineNonEnumerableProperty(this, '$BgLN10', Math.LN10);
        defineNonEnumerableProperty(this, '$BgLN2', Math.LN2);
        defineNonEnumerableProperty(this, '$BgLOG10E', Math.LOG10E);
        defineNonEnumerableProperty(this, '$BgLOG2E', Math.LOG2E);
        defineNonEnumerableProperty(this, '$BgPI', Math.PI);
        defineNonEnumerableProperty(this, '$BgSQRT1_2', Math.SQRT2);
        defineNonEnumerableProperty(this, '$BgSQRT2', Math.SQRT2);
    };
    return ASMath;
}(ASObject));
export { ASMath };
